import { orderBy } from 'lodash';

import { accessApi } from 'utils/injectApi';

export async function getTabelaCondicionantes() {
	const { data } = await accessApi('/boletim/vistoria/condicionantes?incluirDocs=true');
	const { condicionantes = [] } = data;
	return orderBy(condicionantes, 'descricao').filter(c => !c.hidden);
}
